<template>
  <div class="w-full">
    <div class="w-full bg-white">
      <div
        class="flex flex-row justify-between items-center border-b-2 border-orange"
        style="height: 50px"
      >
        <div class="flex flex-row items-center" style="margin-left: 10px;">
          <span class="text-orange text-lg font-bold">収支</span>
          <MinusIcn
            v-if="minusIconFlag()"
            width="16px"
            height="16px"
            class="ml-4 mr-1"
          />
          <span class="text-lg font-bold text-right" style="min-width: 108px;"
            >{{
              Math.abs(timelineTop.income - timelineTop.spent).toLocaleString()
            }}
            円</span
          >
        </div>
        <div class="flex flex-row items-center" style="margin-right: 10px;">
          <span class="text-orange text-lg mr-3">収入</span>
          <span class="text-lg text-right" style="width: 108px;"
            >{{ timelineTop.income.toLocaleString() }} 円</span
          >
          <span class="text-orange text-lg mr-3">｜支出</span>
          <span class="text-lg text-right" style="width: 108px;"
            >{{ timelineTop.spent.toLocaleString() }} 円</span
          >
        </div>
      </div>
      <!-- TODO 未実装のため一旦コメントアウト -->
      <!-- <Disclosure v-slot="{ open }" :defaultOpen="true"> -->
      <Disclosure :defaultOpen="true">
        <DisclosureButton
          class="flex justify-between w-full px-4 py-2 text-sm font-medium text-left focus:outline-none focus-visible:ring-opacity-75 border-orange border-b"
          disabled
        >
          <!-- TODO月区切りで表示する -->
          <span class="text-orange text-lg font-bold">4月</span>
          <!-- <chevron-icn
            width="20px"
            height="20px"
            class="w-5 h-5 orange-icon"
            :class="open ? 'transform rotate-180' : ''"
          ></chevron-icn> -->
        </DisclosureButton>
        <DisclosurePanel>
          <app-table class="w-full">
            <template v-slot:table-body>
              <tr
                class="border-b border-dotted border-orange"
                v-for="(item, index) in filteredItems"
                :key="index"
                @click="openActiveDialog(item)"
              >
                <template v-if="item.documentType == 3">
                  <td
                    class="w-5 border-r border-orange px-0 py-0 mx-0 my-0"
                    style="vertical-align: top;"
                  >
                    <div
                      class="text-lg text-orange bg-orange rounded-full w-5 h-5"
                      style="position: relative; left: 9.5px; top: 5px;"
                    ></div>
                  </td>
                  <td
                    style="padding-left: 16px; width: 150px; vertical-align: top;"
                  >
                    <div class="flex flex-col items-center">
                      <span class="text-lg text-orange font-bold">
                        {{ $filters.dateFormat(item.startDate) }}
                      </span>
                      <span
                        class="text-lg text-orange font-bold"
                        style="transform: rotate(90deg);"
                      >
                        ～
                      </span>
                      <span class="text-lg text-orange font-bold">
                        {{ $filters.dateFormat(item.endDate) }}
                      </span>
                    </div>
                  </td>
                  <td style="vertical-align: top; width: 120px;" class="pl-4">
                    <div class="flex flex-row items-center">
                      <LightningIcn
                        width="20px"
                        height="20px"
                        class="blue-icon mr-1"
                      />
                      <span class="text-blue font-bold text-lg">政務活動</span>
                    </div>
                    <div class="flex flex-col">
                      <div class="flex flex-row items-center">
                        <div class="bg-blue w-4 h-4 rounded-full mr-1"></div>
                        <span class="text-lg">場 所</span>
                      </div>
                      <div class="flex flex-row items-center">
                        <div class="bg-blue w-4 h-4 rounded-full mr-1"></div>
                        <span class="text-lg">参加者</span>
                      </div>
                      <div class="flex flex-row items-center">
                        <div class="bg-blue w-4 h-4 rounded-full mr-1"></div>
                        <span class="text-lg">内 容</span>
                      </div>
                    </div>
                  </td>
                  <td style="vertical-align: top; width: 0px;">
                    <span class="text-blue text-lg mb-1">|</span>
                  </td>
                  <td style="vertical-align: top;">
                    <div class="text-blue text-lg">
                      <span>{{
                        Object.keys(item.actionTypes).length === 1
                          ? item.actionTypes[Object.keys(item.actionTypes)].name
                          : '未設定'
                      }}</span>
                    </div>
                    <div>
                      <span
                        class="text-lg"
                        style="overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1;"
                      >
                        {{ item.place }}
                      </span>
                      <span
                        class="text-lg"
                        style="overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 1;"
                      >
                        {{ item.memberName }}</span
                      >

                      <span
                        class="text-lg"
                        style="overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2;"
                      >
                        {{ item.purpose }}
                      </span>
                    </div>
                  </td>
                  <td style="width: 0px"></td>
                  <td
                    style="width: 112px; vertical-align: top;"
                    class="text-right"
                  >
                    <span class="text-lg"
                      >{{ item.amount.toLocaleString() }} 円</span
                    >
                  </td>
                </template>
                <template v-if="item.documentType == 2">
                  <td
                    class="w-5 border-r border-orange px-0 py-0 mx-0 my-0"
                    style="vertical-align: top;"
                  >
                    <div
                      class="text-lg text-orange bg-orange rounded-full w-5 h-5"
                      style="position: relative; left: 9.5px; top: 5px;"
                    ></div>
                  </td>
                  <td
                    style="padding-left: 16px; width: 150px; vertical-align: top;"
                  >
                    <div class="flex flex-col items-center">
                      <span class="text-lg text-orange font-bold">
                        {{ $filters.dateFormat(item.date) }}
                      </span>
                    </div>
                  </td>
                  <td style="vertical-align: top; width: 120px;" class="pl-4">
                    <div class="flex flex-row items-center">
                      <ReceiptIcn
                        width="20px"
                        height="20px"
                        class="green-icon mr-1"
                        fill-rule="evenodd"
                      />
                      <span class="text-green font-bold text-lg">領収書</span>
                    </div>
                    <div class="flex flex-col">
                      <div class="flex flex-row items-center">
                        <div class="bg-green w-4 h-4 rounded-full mr-1"></div>
                        <span class="text-lg">内 容</span>
                      </div>
                    </div>
                  </td>
                  <td style="vertical-align: top; width: 0px;">
                    <span class="text-green text-lg">|</span>
                  </td>
                  <td style="vertical-align: top;">
                    <div class="text-green text-lg">
                      <span
                        >{{ expenseTypesToString(item.expenseTypeId) }}
                      </span>
                    </div>
                    <div>
                      <span class="text-lg">
                        {{ item.content1 }}
                        {{ item.content2 }}
                      </span>
                    </div>
                  </td>
                  <td style="width: 0px"></td>
                  <td
                    style="width: 112px; vertical-align: top;"
                    class="text-right"
                  >
                    <span class="text-lg"
                      >{{
                        item.amount !== null ? item.amount.toLocaleString() : 0
                      }}
                      円</span
                    >
                  </td>
                </template>
                <template v-if="item.documentType == 1">
                  <td
                    class="w-5 border-r border-orange px-0 py-0 mx-0 my-0"
                    style="vertical-align: top;"
                  >
                    <div
                      class="text-lg text-orange bg-orange rounded-full w-5 h-5"
                      style="position: relative; left: 9.5px; top: 5px;"
                    ></div>
                  </td>
                  <td
                    style="padding-left: 16px; width: 150px; vertical-align: top;"
                  >
                    <div class="flex flex-col items-center">
                      <span class="text-lg text-orange font-bold">
                        {{ $filters.dateFormat(item.date) }}
                      </span>
                    </div>
                  </td>
                  <td style="vertical-align: top; width: 120px;" class="pl-4">
                    <div class="flex flex-row items-center">
                      <MoneyIcn
                        width="20px"
                        height="20px"
                        class="yellow-icon mr-1"
                        fill-rule="evenodd"
                      />
                      <span class="text-yellow font-bold text-lg">予算</span>
                    </div>
                  </td>
                  <td style="vertical-align: top; width: 0px;">
                    <span class="text-yellow text-lg">|</span>
                  </td>
                  <td style="vertical-align: top;">
                    <div class="text-yellow text-lg">
                      <span>{{ contentType(item.contentId) }} </span>
                    </div>
                  </td>
                  <td style="width: 0px">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="8" cy="8" r="8" fill="#B8A000" />
                      <path
                        d="M7 9V13C7 13.5523 7.44771 14 8 14C8.55228 14 9 13.5523 9 13V9H13C13.5523 9 14 8.55228 14 8C14 7.44772 13.5523 7 13 7H9V3C9 2.44772 8.55228 2 8 2C7.44772 2 7 2.44772 7 3V7H3C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9H7Z"
                        fill="white"
                      />
                    </svg>
                  </td>
                  <td style="width: 112px;" class="text-right">
                    <span class="text-lg"
                      >{{ item.amount.toLocaleString() }} 円</span
                    >
                  </td>
                </template>
              </tr>
            </template>
          </app-table>
        </DisclosurePanel>
      </Disclosure>
    </div>
  </div>
</template>

<script>
import { computed, onMounted } from 'vue'
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import AppTable from '@/components/ui/AppTable'

// import ChevronIcn from '@/assets/icons/chevron.svg?inline'
import MinusIcn from '@/assets/icons/minus.svg?inline'
import LightningIcn from '@/assets/icons/lightning-new.svg?inline'
import ReceiptIcn from '@/assets/icons/receipt.svg?inline'
import MoneyIcn from '@/assets/icons/money-circle.svg?inline'
import { useLogs } from '@/services/useLogs'
import { useKeywordSearch } from '@/services/useKeywordSearch'
import { useBudgetDialog } from '@/services/useBudgetDialog'
import { useReceiptDialog } from '@/services/receiptsToda/useReceiptDialog'
import { usePoliticalActionDialog } from '@/services/politicalActionToda/usePoliticalActionDialog'
import { useDialog } from '@/services/useDialog'
import { expenseTypesToString } from '@/services/useExpenseType'
import { useYearSelector } from '@/services/useYearSelector'

export default {
  name: 'AppTimeline_TODA',

  components: {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
    AppTable,
    // ChevronIcn,
    MinusIcn,
    LightningIcn,
    ReceiptIcn,
    MoneyIcn,
  },

  setup() {
    const { currentYear } = useYearSelector()
    const { getTimelineTop, timelineTop } = useLogs()
    const { keyword } = useKeywordSearch()
    const { openBudgetPreview } = useBudgetDialog()
    const { openReceiptDialog } = useReceiptDialog()
    const { changeDocument } = usePoliticalActionDialog()
    const { isOpen, type } = useDialog()

    onMounted(async () => {
      await getTimelineTop(currentYear.value)
    })

    const openActiveDialog = item => {
      if (item.documentType === 1) {
        openBudgetPreview(item.id)
        return
      }

      if (item.documentType === 2) {
        openReceiptDialog(item.id)
        return
      }
      if (
        item.documentType === 3 ||
        item.documentType === 4 ||
        item.documentType === 5
      ) {
        changeDocument(item.documentType, item.id)
        return
      }
    }

    const contentType = type => {
      switch (type) {
        case 0:
          return '交付金'
        case 1:
          return '前期交付金'
        case 2:
          return '後期交付金'
        case 3:
          return '一部変返還'
        case 4:
          return '決算利息'
      }
    }

    const filteredItems = computed(() => {
      return filterByKeyword(timelineTop.value)
    })

    const filterByKeyword = items => {
      return items.contents.filter(function(item) {
        if (keyword.value.length == 0) {
          return true
        }
        return (
          (item['amount'] &&
            item['amount'].toString().includes(keyword.value)) ||
          (item['content1'] && item['content1'].includes(keyword.value)) ||
          (item['content2'] && item['content2'].includes(keyword.value)) ||
          (item['place'] && item['place'].includes(keyword.value)) ||
          (item['memberName'] && item['memberName'].includes(keyword.value)) ||
          (item['purpose'] && item['purpose'].includes(keyword.value))
        )
      })
    }

    const minusIconFlag = () => {
      const incomeAndExpenditure =
        timelineTop.value.income - timelineTop.value.spent
      return incomeAndExpenditure < 0
    }

    return {
      timelineTop,
      keyword,
      filteredItems,
      expenseTypesToString,
      contentType,
      isOpen,
      type,
      openActiveDialog,
      minusIconFlag,
    }
  },
}
</script>
<style lang="scss" scoped>
td {
  padding-bottom: 10px;
}
</style>
